import { mapState } from "vuex";
import moment from "moment";
import _ from "lodash";


export default {
    data(){
      return{
          calendarList:[
              {
                  cal:'DEP',
                  from:'deposit_at_from',
                  to:'deposit_at_to',
                  default:'TODAY',
              },
              {
                  cal:'REG',
                  from:'registered_on_from',
                  to:'registered_on_to',
                  default:'TODAY',
              },
              {
                  cal:'CA_F',
                  from:'scheduled_call_to_from',
                  to:'scheduled_call_to_to',
                  default:null,
              },
              {
                  cal:'TRA',
                  from:'last_transfer_from',
                  to:'last_transfer_to',
                  default:null,
              },
              {
                  cal:'REF',
                  from:'last_referral_from',
                  to:'last_referral_to',
                  default:null,
              },
              {
                  cal:'LEAD_TAG',
                  from:'last_modified_lead_from',
                  to:'last_modified_lead_to',
                  default:null,
              },
              {
                  cal:'NA_TAG',
                  from:'last_modified_na_from',
                  to:'last_modified_na_to',
                  default:null,
              },
              {
                  cal:'ASSIGN',
                  from:'assigned_at_from',
                  to:'assigned_at_to',
                  default:null,
              },

          ],
          dates:{},
          presets: [
              {
                  id: 1,
                  alias: "TODAY",
                  alias_preset: "TODAY",
                  name: "T",
                  default: true,
                  presetTab: true
              },
              {
                  id: 2,
                  alias: "YESTERDAY",
                  alias_preset: "YESTERDAY",
                  name: "Y",
                  default: false,
                  presetTab: true
              },
              {
                  id: 3,
                  alias: "T_WEEK",
                  alias_preset: "T_WEEK",
                  name: "THIS W",
                  default: false,
                  presetTab: true
              },
              {
                  id: 4,
                  alias: "L_WEEK",
                  alias_preset: "L_WEEK",
                  name: "LAST W",
                  default: false,
                  presetTab: true
              },
              {
                  id: 4,
                  alias: "MONTH",
                  alias_preset: "MONTH",
                  name: "THIS M",
                  default: false,
                  presetTab: true
              },
              {
                  id: 4,
                  alias: "LAST_MONTH",
                  alias_preset: "LAST_MONTH",
                  name: "LAST M",
                  default: false,
                  presetTab: true
              },



          ]
      }
    },
    mounted(){

    },
    computed: {
        ...mapState("clients", ["generalQueryObject","showReset"])
    },
    methods: {
        defaultPresets2(range) {
            if (range === "TODAY") {
                const n = new Date();
                const today = new Date(
                    Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0)
                );
                return {
                    start: today,
                    end: today
                };
            }
            if (range === "YESTERDAY") {
                const n = new Date();
                const start = new Date(
                    Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 1)
                );
                // const end = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()))
                return {
                        start: start,
                        end: start
                };
            }
            if (range === "WEEK") {
                const n = new Date();
                const start = moment()
                    .startOf("isoWeek")
                    .toDate();
                const end = new Date(
                    Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0)
                );
                return {
                        start: start,
                        end: end
                };
            }
            if (range === "T_WEEK") {
                const n = new Date();
                const start = moment()
                    .startOf("isoWeek")
                    .toDate();
                const end = moment().toDate();
                return {
                        start: start,
                        end: end
                };
            }
            if (range === "L_WEEK") {
                const start = moment()
                    .subtract(1, "week")
                    .startOf("isoWeek")
                    .toDate();
                const end = moment()
                    .subtract(1, "week")
                    .endOf("isoWeek")
                    .toDate();
                return {
                        start: start,
                        end: end
                };
            }
            if (range === "MONTH") {
                const n = new Date();
                let startMonth = moment()
                    .startOf("month")
                    .toDate();
                const endMonth = moment()
                    .toDate();
                return {
                        start: startMonth,
                        end: endMonth
                };
            }
            if (range === "MONTH_F") {
                const n = new Date();
                let month = n.getMonth() + 1;

                let startMonth = moment().toDate();
                let endMonth = moment()
                    .endOf("month")
                    .toDate();
                return {
                        start: startMonth,
                        end: endMonth
                };
            }
            if (range === "LAST_MONTH") {
                const n = new Date();
                const startMonth = new Date(
                    Date.UTC(n.getFullYear(), n.getMonth() - 1, 1)
                );
                const endMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 0));
                return {
                        start: startMonth,
                        end: endMonth
                };
            }
            if (range === "QUARTER") {
                const start = moment()
                    .subtract(1, "quarter")
                    .toDate();
                const end = moment().toDate();
                return {
                        start: start,
                        end: end

                };
            }
            if (range === "HALF_YEAR") {
                const start = moment()
                    .subtract(6, "months")
                    .toDate();
                const end = moment().toDate();
                return {
                        start: start,
                        end: end

                };
            }

            if (range === "LAST_30_DAYS") {
                const n = new Date();
                const start = new Date(
                    Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 30)
                );
                const end = new Date(
                    Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
                );
                return {
                        start: start,
                        end: end
                };
            }
            if (range === "LAST_90_DAYS") {
                const n = new Date();
                const start = new Date(
                    Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 90)
                );
                const end = new Date(
                    Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
                );
                return {
                        start: start,
                        end: end
                };
            }
            if (range === "LAST_180_DAYS") {
                const n = new Date();
                const start = new Date(
                    Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 180)
                );
                const end = new Date(
                    Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
                );
                return {
                        start: start,
                        end: end
                };
            }
            if (range === "TOMORROW") {
                const n = new Date();
                const start = new Date(
                    Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() + 1)
                );
                return {
                        start: start,
                        end: start
                };
            }
            if (range === "N_MONTH") {
                const n = new Date();
                const startMonth = new Date(
                    Date.UTC(n.getFullYear(), n.getMonth() + 1, 1)
                );
                const endMonth = new Date(
                    Date.UTC(n.getFullYear(), n.getMonth() + 2, 0)
                );
                return {
                        start: startMonth,
                        end: endMonth
                };
            }
            if (range === "N_Q") {
                const start = moment().toDate();
                const end = moment()
                    .add(3, "months")
                    .toDate();
                return {
                        start: start,
                        end: end
                };
            }
            if (range === "N_Y") {
                const start = moment().toDate();
                const end = moment()
                    .add(1, "year")
                    .toDate();
                return {
                        start: start,
                        end: end
                };
            }
            return false
        },

        validPreset(cal){
            let preset = null
            let calendar = this.calendarList.find(calendar=>{
                return calendar.cal === cal
            })
            if(calendar){
                if(!this.showReset){
                    return calendar.default
                }
                let callBack = false;
                this.presets.map(tab=>{
                    if(!callBack){
                       callBack =    this.generalQueryObject[calendar.from] === moment(this.defaultPresets2(tab.alias).start).format('YYYY-MM-DD') &&
                                     this.generalQueryObject[calendar.to] === moment(this.defaultPresets2(tab.alias).end).format('YYYY-MM-DD')
                        callBack? preset = tab.alias :null
                    }
                })
                return preset;
            }
        },

    }
};